"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEMaterial = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Material that are used by the individual applications AE.
 */
const allowedMaterial = ['NC', 'ESD', 'HT', 'DT', 'EG+'];
exports.AEMaterial = {
    [echain_shared_igus_fundamentals_1.AppName.EIQ]: allowedMaterial,
    // EKE it's not allowed to change the material for AE's
    [echain_shared_igus_fundamentals_1.AppName.EKE]: [],
    // EIC, ECF has no ae's
    [echain_shared_igus_fundamentals_1.AppName.EIC]: [],
    [echain_shared_igus_fundamentals_1.AppName.ECF]: [],
    [echain_shared_igus_fundamentals_1.AppName.TEST]: [],
};
//# sourceMappingURL=AEMaterial.js.map